export default {
    name: 'mustBePositiveInteger',
    validate(modelValue, viewValue /* record, options */) {
        const value = viewValue || modelValue;
        if (value === '') return true;
        if (!value) return false;
        return /^\d+$/.test(value);
    },
};
